import React from 'react';
import { CreditCard, BarChart2, Shield, Zap, FileText, Users, Database, Smartphone } from 'lucide-react';
const FeaturesGrid = () => {
  const features = [{
    icon: CreditCard,
    title: 'Payment Methods',
    description: 'Support for all Malaysian payment methods including FPX, bank transfers, and credit cards.',
    items: ['FPX Integration', 'Local Bank Transfers', 'International Payments', 'Credit Card Support']
  }, {
    icon: BarChart2,
    title: 'Reporting & Analytics',
    description: 'Comprehensive reporting tools to track and analyze your payment data.',
    items: ['Spending Analytics', 'Vendor Reports', 'Custom Dashboards', 'Export to Excel/CSV']
  }, {
    icon: Shield,
    title: 'Security & Compliance',
    description: 'Bank-grade security and compliance with Malaysian regulations.',
    items: ['Bank-Level Encryption', 'Two-Factor Authentication', 'Role-Based Access', 'Audit Trails']
  }, {
    icon: Zap,
    title: 'Automation',
    description: 'Powerful automation to streamline your payment processes.',
    items: ['Recurring Payments', 'Approval Workflows', 'Payment Scheduling', 'Auto-Categorization']
  }, {
    icon: FileText,
    title: 'Invoice Management',
    description: 'Comprehensive tools for managing all your invoices in one place.',
    items: ['OCR Data Extraction', 'Invoice Matching', 'Duplicate Detection', 'Digital Storage']
  }, {
    icon: Users,
    title: 'Vendor Management',
    description: 'Maintain and manage all your vendor relationships efficiently.',
    items: ['Vendor Profiles', 'Payment History', 'Vendor Onboarding', 'Performance Tracking']
  }, {
    icon: Database,
    title: 'Integrations',
    description: 'Connect with your existing business tools and software.',
    items: ['Accounting Software', 'ERP Systems', 'Banking Platforms', 'API Access']
  }, {
    icon: Smartphone,
    title: 'Mobile Access',
    description: 'Manage payments on the go with our mobile-friendly platform.',
    items: ['Mobile Web App', 'WhatsApp Integration', 'SMS Notifications', 'Approval via Mobile']
  }];
  return <section className="section" data-id="element-37">
      <div className="container" data-id="element-38">
        <div className="text-center mb-16" data-id="element-39">
          <h2 className="font-outfit font-bold text-3xl md:text-4xl mb-6" data-id="element-40">
            Comprehensive Features
          </h2>
          <p className="text-slate-grey text-lg max-w-3xl mx-auto" data-id="element-41">
            Everything you need to streamline your bill payments and improve
            financial operations.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-42">
          {features.map((feature, index) => {
          const Icon = feature.icon;
          return <div key={index} className="card hover:shadow-md transition-all duration-300" data-id="element-43">
                <div className="flex items-center mb-4" data-id="element-44">
                  <div className="bg-light-sky p-2 rounded-lg mr-3" data-id="element-45">
                    <Icon className="h-6 w-6 text-settl-blue" data-id="element-46" />
                  </div>
                  <h3 className="font-outfit font-semibold text-lg" data-id="element-47">
                    {feature.title}
                  </h3>
                </div>
                <p className="text-slate-grey text-sm mb-4" data-id="element-48">
                  {feature.description}
                </p>
                <ul className="space-y-2" data-id="element-49">
                  {feature.items.map((item, i) => <li key={i} className="flex items-center text-sm" data-id="element-50">
                      <svg className="h-4 w-4 text-success-green mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-51">
                        <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-52" />
                      </svg>
                      {item}
                    </li>)}
                </ul>
              </div>;
        })}
        </div>
      </div>
    </section>;
};
export default FeaturesGrid;